import { SET_CHAT_OPENED_WINDOWS } from '../../constants/ActionTypes';
import setChatOpenedWindows from './setChatOpenedWindows';
import cloneDeep from 'lodash/cloneDeep';


export default function appendChatOpenedWindows(value) {
  return (dispatch, getState)=>{
    let openedWindows=cloneDeep(getState().chat_opened_windows);
    if(openedWindows.indexOf(parseInt(value)) === -1) {
      openedWindows.push(parseInt(value));
      console.log('opened ',openedWindows)
      dispatch(setChatOpenedWindows(openedWindows));
    }
    //console.log('STATE',getState());
    /*type: SET_CHAT_OPENED_WINDOWS,
    value: value*/
  }
}

